import { useEffect, useState } from 'react';
import api from 'entity/reward/rewardApi';

interface RewardFilter {
  title: string;
  value: string;
}

const useFilterList = () => {
  const [rewardFilter, setRewardFilter] = useState<RewardFilter[]>([
    {
      title: 'All Rewards',
      value: 'all',
    },
  ]);

  useEffect(() => {
    const getRewardFilter = async () => {
      const response = await api.getRewardCategoriesFilter();
      if (response.ok) {
        const mappedData = response.data.data.map(filter => {
          return {
            title: filter.name,
            value: filter.slug,
          };
        });
        setRewardFilter([
          {
            title: 'All Rewards',
            value: 'all',
          },
          ...mappedData,
          {
            title: 'Tier: Millionaire Only',
            value: 'tier1',
          },
          {
            title: 'Tier: Billionaire & Below',
            value: 'tier1&2',
          },
        ]);
      }
    };
    getRewardFilter();
  }, []);

  return rewardFilter;
};

export default useFilterList;
